"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      opacity: '0',
      marginTop: -40,
      height: 40
    }
  };
};
var HiSelectMobile = /*#__PURE__*/function (_React$Component) {
  function HiSelectMobile() {
    var _this;
    (0, _classCallCheck2.default)(this, HiSelectMobile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HiSelectMobile, [].concat(args));
    _this.buildOptionList = function (itemList) {
      var optionList = [];
      if (itemList.length) {
        var parentId;
        var groupList = [];
        itemList.forEach(function (item) {
          if (item.id !== '_all' && item.displayed !== false) {
            if (item.hasChildren) {
              if (groupList.length) {
                optionList.push(_this.buildChildrenList(groupList));
                groupList = [];
              }
              parentId = item.id;
              groupList.push(item);
            } else if (parentId) {
              groupList.push(item);
            } else if (item.children) {
              optionList.push(_this.buildChildrenList([item].concat((0, _toConsumableArray2.default)(item.children))));
            } else {
              optionList.push( /*#__PURE__*/_react.default.createElement("option", {
                key: item.id,
                "data-item": JSON.stringify(item),
                value: item.id
              }, item.label));
            }
          }
        });
        if (groupList.length) {
          optionList.push(_this.buildChildrenList(groupList));
        }
      }
      return optionList;
    };
    _this.buildChildrenList = function (itemList) {
      var group = itemList.shift();
      return /*#__PURE__*/_react.default.createElement("optgroup", {
        key: group.id,
        label: group.label
      }, itemList.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: item.id,
          "data-item": JSON.stringify(item),
          value: item.id
        }, item.label);
      }));
    };
    _this.handleChange = function (event) {
      if (!_this.props.multiple) {
        var itemSelected = event.target[event.target.selectedIndex];
        _this.props.onChange(event, JSON.parse(itemSelected.getAttribute('data-item')));
      } else {
        // Multiple on mobile trigger on change with all selected items
        var optionsSelected = [];
        Array.prototype.forEach.call(event.target.options, function (option) {
          if (option.selected) {
            optionsSelected.push(JSON.parse(option.getAttribute('data-item')));
          }
        });
        _this.props.onChange(event, optionsSelected);
      }
    };
    return _this;
  }
  (0, _inherits2.default)(HiSelectMobile, _React$Component);
  return (0, _createClass2.default)(HiSelectMobile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        id = _this$props.id,
        itemList = _this$props.itemList,
        multiple = _this$props.multiple,
        value = _this$props.value;
      var additionalProps = (0, _objectSpread2.default)({}, multiple && {
        multiple: 'multiple'
      });
      return /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
        value: value,
        style: {
          width: this.props.width
        },
        onChange: this.handleChange,
        className: classes.root,
        name: id,
        id: id
      }, additionalProps), this.buildOptionList(itemList));
    }
  }]);
}(_react.default.Component);
HiSelectMobile.defaultProps = {
  itemList: []
};
var _default = exports.default = (0, _withStyles.default)(styles)(HiSelectMobile);